<template>
    <div class="vuelist">
        <div class="tabs">
            <div class="tab" :class="[active==0?'active':'']" @click="onChange(0,null)">全部</div>
            <div class="tab" v-for="(item,index) in list" :class="[active==index+1?'active':'']" :key="item.id" @click="onChange(index+1,item.value)">
                {{item.text}}
            </div>
        </div>
        <div class="right">
            <div class="header">
                <div class="title">场地列表</div>
                <Search v-model="keyword" shape="round" @search="onSearch" placeholder="场馆名称" />
            </div>
            <List
                v-model:loading="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getlist"
                >
                <div class="item" v-for="item in vlist" @click="godetail(item)">
                    <img :src="item.icon" alt="">
                    <div class="tt">
                        <div>
                            <div>{{item.name}}</div>
                            <div>地址：{{item.addres}}</div>
                        </div>
                        <div><span>{{typeFiler(item.type)}}</span></div>
                    </div>
                </div>
            </list>
        </div>       
    </div>
</template>

<script>
import { getTypeList,getVList } from "@/libs/api";
import { Search,List } from 'vant'
export default {
    data() {
        return {
            loading: false,
            finished: false,
            active: 0,
            page: 1,
            type: '',
            keyword: '',
            list: [],
            vlist: []
        }
    },
    components: {Search,List},
    mounted() {
        getTypeList().then(res=>{
            if(res.status === "0000") {
               this.list = res.data
            }
        }) 
    },
    watch: {
        keyword(value) {
            this.finished = false
            this.page = 1
            this.getlist()
        },
        type(val) {
            this.finished = false
            this.page = 1
            this.getlist() 
        }
    },
    methods: {
        onChange(index,value) {
            this.active = index
            this.type = value
        },
        typeFiler(value){
            const item = this.list.find((re) => re.value*1===value*1)
    	    return item.text||''
        },
        godetail(item) {
            this.$router.push({name:'venuedetail',params:{id:item.id}})
        },
        onSearch(val) {
            this.keyword = val
        },
        getlist() {
            let query = {
                type: this.type,
                name: this.keyword,
                pageIndex: this.page,
                pageSize: 10
            }
            Object.keys(query).forEach(k => (query[k]==='') && delete query[k])
            console.log(query,'query')
            getVList(query).then(res=>{
                this.loading = false
                let { pageIndex,pageCount,data } = res
                data.forEach((item)=>{
                    if(item.icon.indexOf('/v3/') === -1) {
                        item.icon = item.icon.replace('https://changning.movecloud.cn/','https://changning.movecloud.cn/v3/')
                    }
                    
                })
                if(pageIndex === 1) {
                    this.vlist = data
                } else {
                    this.vlist = this.vlist.concat(data)
                }

                if(pageIndex >= pageCount) {
                    this.finished = true;
                } else {
                    this.page++ 
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.vuelist{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    overflow-x: hidden;
    overflow-y: hidden;
    .tabs{
        width: 16%;
        height: 100vh;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        // justify-content: center;
        overflow-x: hidden;
        overflow-y: scroll;
        .tab{
            width: 100%;
            height: 61px;
            // line-height: 121px;
            text-align: center;
            font-size: 14px;
            background: #F4F8FB;
            color: #999;
            box-sizing: border-box;
            padding: 0 1px;
            word-wrap:break-word; 
            word-break:break-all; 
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .active{
            box-sizing: border-box;
            background: #fff;
            border-left: 5px solid #1A94FF;
            color: #1A94FF;
        }

    }
    .right{
        width: 83%;
        height: 100vh;
        overflow-x: hidden;
        overflow-y: scroll;
        .header{
            background: url(https://oss.mcloud.moveclub.cn/alphamovecloud/20220817/1660724813/844735.png) no-repeat;
            background-size: 100% 100%;
            width: 100%;
            height: 99px;
            box-sizing: border-box;
            padding: 19px 0 14px 3px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title{
                font-size: 18px;
                color: #000;
                font-weight: bold;
                text-align: left;
            }
            --van-search-background-color: transparent; 
            --van-search-padding: 0px 11px 0 0;
        }
        .van-list{
            box-sizing: border-box;
            padding: 0 12px;
            .item{
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 13px 0;
                border-bottom: 1px solid #EBEBEB;
                img{
                    width: 78px;
                    height: 78px;
                    border-radius: 4.2px;
                }
                
                .tt{
                    max-width: 204px;
                    display: flex;
                    height: 78px;
                    padding-left: 9.5px;
                    flex-direction: column;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 2.5px 0 5px 9.5px;
                    >div:first-child{
                        >div:first-child{
                            font-size: 14px;
                            color: rgba(0,0,0,0.85);
                            font-weight: 600;
                        }
                        >div:nth-child(2){
                            font-size: 11px;
                            color: rgba(0,0,0,0.45);
                            font-weight: 400;
                            padding-top: 3px;
                        }
                    }
                    >div:nth-child(2)>span{
                        background: #E7F4FF;
                        border-radius: 1px;
                        box-sizing: border-box;
                        padding: 2.5px 7.5px;
                        text-align: center;
                        font-size: 10px;
                        color: #5191C1;
                        font-weight: 400;
                    }
                }
            }
        }
            
    }
    
}
</style>